import React from 'react';
import ReactDOM from 'react-dom/client';
import { register } from './serviceWorkerRegistration';

import App from './App';

import './index.css';
import "bootstrap/dist/css/bootstrap.css"

register();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
